import React from 'react'

import { AppBar, Avatar, Toolbar, Box, Divider, Typography, Button } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

// import { ReactComponent as NewSaleIcon } from './assets/icons/newSale.svg'
import ContextMenu from './ContextMenu'
import MenuButton from './MenuButton'
import useBrand from './useBrand'

import { CustomTheme } from '../../theme/utils'

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    toolBar: {
      alignItems: 'center',
      display: 'flex',
      height: theme.spacing(14),
      minHeight: theme.spacing(14),
      padding: '0px',
    },
    toolBarElement: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
    },
    rightElement: {
      width: '40%',
    },
    leftElement: {
      width: '60%',
    },
    avatar: {
      height: theme.spacing(9),
      marginLeft: theme.spacing(4),
      width: theme.spacing(9),
    },
    title: {
      marginLeft: theme.spacing(5),
      color: theme.palette.text.primary,
    },
    iconButton: {
      borderRadius: theme.spacing(1),
      height: theme.spacing(10),
      margin: theme.spacing(0, 4, 0, 4),
      minWidth: 'auto',
      padding: '0px',
      width: theme.spacing(8),
    },
    divider: {
      margin: theme.spacing(0, 4, 0, 4),
      width: theme.spacing(0.5),
    },
  })
})

interface HeaderProps {
  children?: React.ReactNode
  saleButtons?: boolean
  theme: string
  title: string
  agentName?: string
  onHandleLogout: () => void
  onChangeBrand: (brand: string) => void
  onAddSubscription?: () => void
  onNewSale?: () => void
  onOpenMenu?: () => void
}

export default function Header({
  children,
  saleButtons,
  theme,
  title,
  agentName,
  onHandleLogout,
  onChangeBrand,
  onAddSubscription,
  onNewSale,
  onOpenMenu,
}: HeaderProps) {
  const classes = useStyles()
  const { selectedBrand } = useBrand(theme)

  return (
    <Box data-hook="app-header">
      <AppBar color="primary" position="fixed">
        <Toolbar className={classes.toolBar}>
          <Box className={`${classes.toolBarElement} ${classes.rightElement}`}>
            <MenuButton onOpenMenu={onOpenMenu} />
            <Divider flexItem orientation="vertical" />
            <Avatar className={classes.avatar}>{selectedBrand.avatar}</Avatar>
            <Typography className={classes.title} variant="h3">
              {title}
            </Typography>
          </Box>
          <Box
            className={`${classes.toolBarElement} ${classes.leftElement}`}
            flexDirection="row-reverse"
          >
            <ContextMenu
              onHandleLogout={onHandleLogout}
              onChangeBrand={onChangeBrand}
              theme={theme}
              agentName={agentName}
            />
            <Divider className={classes.divider} flexItem orientation="vertical" />
            {saleButtons === true ? (
              <>
                <Box ml={4}>
                  <Button
                    data-hook="new-client-button"
                    variant="contained"
                    color="secondary"
                    onClick={onAddSubscription}
                  >
                    Nuevo cliente
                  </Button>
                </Box>
                {/* <Button
                  className={classes.iconButton}
                  variant="contained"
                  color="secondary"
                  onClick={onNewSale}
                >
                  <NewSaleIcon />
                </Button> */}
              </>
            ) : null}
            {children}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
